import {
    CardHeader,
    Divider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { EngageDailyReportItem } from '../../sic-lib/api/activityReport/types/ActivityReport';
import { groupEngageReport } from '../../sic-lib/utils/activityReportHelper';
import DisplayPhoneNumber from '../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface Props {
    twilioStats: EngageDailyReportItem[];
}

export default function NewContactsReport({ twilioStats }: Props) {
    const { classes } = useStyles();

    const newContactsData = React.useMemo(() => {
        return groupEngageReport(twilioStats);
    }, [twilioStats]);

    if (newContactsData.dailyReports.length === 0) {
        return <></>;
    }
    return (
        <Paper className={classes.root}>
            <CardHeader title="Usage Activity Report" />
            <Divider />
            <TableContainer component={Paper}>
                <Table size="small" aria-label="usage-activity-report">
                    <TableHead>
                        <TableRow>
                            <TableCell>Username</TableCell>
                            <TableCell align="center">Number</TableCell>
                            <TableCell align="center">Appointments</TableCell>
                            <TableCell align="center">Call Backs</TableCell>
                            <TableCell align="center">Calls Inbound</TableCell>
                            <TableCell align="center">Calls Outbound</TableCell>
                            <TableCell align="center">SMS Inbound</TableCell>
                            <TableCell align="center">SMS Outbound</TableCell>
                            <TableCell align="center">Email Inbound</TableCell>
                            <TableCell align="center">Email Outbound</TableCell>
                            <TableCell align="center">Ring less VM</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {newContactsData.dailyReports.map(item => {
                            return (
                                <TableRow
                                    key={item.numberId}
                                    hover
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell>{item.userName}</TableCell>
                                    <TableCell align="center" width="130">
                                        <DisplayPhoneNumber phoneNumber={item.number} />
                                    </TableCell>
                                    <TableCell align="center">{item.appointments}</TableCell>
                                    <TableCell align="center">{item.callBacks}</TableCell>
                                    <TableCell align="center">{item.callsInbound}</TableCell>
                                    <TableCell align="center">{item.callsOutbound}</TableCell>
                                    <TableCell align="center">{item.smsInbound}</TableCell>
                                    <TableCell align="center">{item.smsOutbound}</TableCell>
                                    <TableCell align="center">{item.gmailInbound}</TableCell>
                                    <TableCell align="center">{item.gmailOutbound}</TableCell>
                                    <TableCell align="center">{item.ringlessVM}</TableCell>
                                </TableRow>
                            );
                        })}
                        {newContactsData.dailyReports.length > 1 && (
                            <TableRow
                                key={`${twilioStats.length}-total`}
                                hover
                                className={classes.totalsRow}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell className={classes.totalsStyles}>Totals</TableCell>
                                <TableCell></TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalAppointments}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalCallBacks}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalCallsInbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalCallsOutbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalSmsInbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalSmsOutbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalGmailInbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalGmailOutbound}
                                </TableCell>
                                <TableCell className={classes.totalsStyles} align="center">
                                    {newContactsData.totalRinglessVM}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(2),
    },
    totalsRow: {
        backgroundColor: theme.palette.info.light,
        '&.MuiTableRow-root:hover': {
            backgroundColor: theme.palette.info.light,
        },
    },
    totalsStyles: {
        fontWeight: 'bold',
    },
}));
